import { useQuery } from '@tanstack/react-query';
import { getTenantConfig } from './api';
import { useAuthStore } from './auth-store';

/**
 * Whether to render a Report affordance at all.
 *
 * Two conditions, both required. The tenant flag arrives already ANDed with
 * `lmsEnabled` server-side, so it is read as-is — a non-LMS tenant never sends
 * a true. And `POST /reports` is auth-only, so a logged-out visitor browsing
 * the public course page must not be offered a button that can only bounce
 * them into the login form.
 *
 * Its own file rather than a second export on the dialog, so the component
 * file stays fast-refresh clean.
 */
export function useAbuseReporting(): boolean {
  const authed = !!useAuthStore((s) => s.token);
  // Same query key the storefront's `useTenantConfig` uses, so this shares the
  // one cached config fetch instead of adding a request per report button.
  const cfg = useQuery({ queryKey: ['tenant-config'], queryFn: getTenantConfig });
  return authed && cfg.data?.abuseReportingEnabled === true;
}
